
import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import EditIcon from '@mui/icons-material/Edit';
import { Autocomplete, IconButton, ListItem, ListItemText, Stack, TextField, Tooltip } from '@mui/material';
import { Form, Formik, getIn } from 'formik';
import * as Yup from "yup"
import { Close } from '@mui/icons-material';
import { baseUrl } from '../../utils/baseUrl';
import { useUpdateConnectionMutation } from '../../Slices/roomNateApis';
import { ErrorAlert, SuccessAlert } from '../../utils/Alerts';
import { LoadingButton } from '@mui/lab';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    height: "90%",
    overflowY: "auto",
    width: { xs: '90%', md: "650px" },
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function BasicModal({ items, connectionPointsData, item, connectionPointsOptionsData }) {

    const [load, setLoad] = React.useState(false)

    const [updateConnection, resultStats] = useUpdateConnectionMutation()

    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);

    const ref = React.useRef(null)
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const validationSchema = Yup.object().shape({
        item1: Yup.mixed().required("You must have to select one item"),
        item2: Yup.mixed().required("You must have to select one item")
    });

    React.useEffect(() => {
        if (resultStats?.isLoading) {
            setLoad(true)
        }

        if (!resultStats?.isLoading) {
            setLoad(false)
        }

        if (resultStats?.isSuccess) {
            setSuccessAlert(true)
            setTimeout(() => {
                setSuccessAlert(false)
            }, 2000);
            handleClose()
        }

        if (resultStats?.isError) {
            setErrorAlert(true)
            setTimeout(() => {
                setErrorAlert(false)
            }, 2000);

        }
    }, [resultStats])

    return (
        <>
            {successAlert &&
                <SuccessAlert title="Connection has been updated successfully!" />
            }

            {errorAlert &&
                <ErrorAlert title="Something Went Wrong!" />
            }

            <Tooltip title="Edit">
                <IconButton color='primary' onClick={handleOpen}>
                    <EditIcon />
                </IconButton>
            </Tooltip>

            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box position="fixed" top={10} right={0}>
                        <IconButton onClick={handleClose}>
                            <Close />
                        </IconButton>
                    </Box>
                    <Formik
                        innerRef={ref}
                        enableReinitialize={true}
                        initialValues={{
                            item1: item?.item1,
                            item2: item?.item2,
                            north: {
                                north: item?.north?.north,
                                south: item?.north?.south,
                                east: item?.north?.east,
                                west: item?.north?.west,
                                northwest: item?.north?.northwest,
                                northeast: item?.north?.northeast,
                                southeast: item?.north?.southeast,
                                southwest: item?.north?.southwest,
                                center: item?.north?.center,
                                top: item?.north?.top,
                                bottom: item?.north?.bottom,
                                cce: item?.north?.cce,
                                ccw: item?.north?.ccw
                            },
                            south: {
                                north: item?.south?.north,
                                south: item?.south?.south,
                                east: item?.south?.east,
                                west: item?.south?.west,
                                northwest: item?.south?.northwest,
                                northeast: item?.south?.northeast,
                                southeast: item?.south?.southeast,
                                southwest: item?.south?.southwest,
                                center: item?.south?.center,
                                top: item?.south?.top,
                                bottom: item?.south?.bottom,
                                cce: item?.south?.cce,
                                ccw: item?.south?.ccw
                            },
                            east: {
                                north: item?.east?.north,
                                south: item?.east?.south,
                                east: item?.east?.east,
                                west: item?.east?.west,
                                northwest: item?.east?.northwest,
                                northeast: item?.east?.northeast,
                                southeast: item?.east?.southeast,
                                southwest: item?.east?.southwest,
                                center: item?.east?.center,
                                top: item?.east?.top,
                                bottom: item?.east?.bottom,
                                cce: item?.east?.cce,
                                ccw: item?.east?.ccw

                            },
                            west: {
                                north: item?.west?.north,
                                south: item?.west?.south,
                                east: item?.west?.east,
                                west: item?.west?.west,
                                northwest: item?.west?.northwest,
                                northeast: item?.west?.northeast,
                                southeast: item?.west?.southeast,
                                southwest: item?.west?.southwest,
                                center: item?.west?.center,
                                top: item?.west?.top,
                                bottom: item?.west?.bottom,
                                cce: item?.west?.cce,
                                ccw: item?.west?.ccw

                            },
                            northwest: {
                                north: item?.northwest?.north,
                                south: item?.northwest?.south,
                                east: item?.northwest?.east,
                                west: item?.northwest?.west,
                                northwest: item?.northwest?.northwest,
                                northeast: item?.northwest?.northeast,
                                southeast: item?.northwest?.southeast,
                                southwest: item?.northwest?.southwest,
                                center: item?.northwest?.center,
                                top: item?.northwest?.top,
                                bottom: item?.northwest?.bottom,
                                cce: item?.northwest?.cce,
                                ccw: item?.northwest?.ccw

                            },
                            northeast: {
                                north: item?.northeast?.north,
                                south: item?.northeast?.south,
                                east: item?.northeast?.east,
                                west: item?.northeast?.west,
                                northwest: item?.northeast?.northwest,
                                northeast: item?.northeast?.northeast,
                                southeast: item?.northeast?.southeast,
                                southwest: item?.northeast?.southwest,
                                center: item?.northeast?.center,
                                top: item?.northeast?.top,
                                bottom: item?.northeast?.bottom,
                                cce: item?.northeast?.cce,
                                ccw: item?.northeast?.ccw

                            },
                            southwest: {
                                north: item?.southwest?.north,
                                south: item?.southwest?.south,
                                east: item?.southwest?.east,
                                west: item?.southwest?.west,
                                northwest: item?.southwest?.northwest,
                                northeast: item?.southwest?.northeast,
                                southeast: item?.southwest?.southeast,
                                southwest: item?.southwest?.southwest,
                                center: item?.southwest?.center,
                                top: item?.southwest?.top,
                                bottom: item?.southwest?.bottom,
                                cce: item?.southwest?.cce,
                                ccw: item?.southwest?.ccw

                            },
                            southeast: {
                                north: item?.southeast?.north,
                                south: item?.southeast?.south,
                                east: item?.southeast?.east,
                                west: item?.southeast?.west,
                                northwest: item?.southeast?.northwest,
                                northeast: item?.southeast?.northeast,
                                southeast: item?.southeast?.southeast,
                                southwest: item?.southeast?.southwest,
                                center: item?.southeast?.center,
                                top: item?.southeast?.top,
                                bottom: item?.southeast?.bottom,
                                cce: item?.southeast?.cce,
                                ccw: item?.southeast?.ccw

                            },
                            center: {
                                north: item?.center?.north,
                                south: item?.center?.south,
                                east: item?.center?.east,
                                west: item?.center?.west,
                                northwest: item?.center?.northwest,
                                northeast: item?.center?.northeast,
                                southeast: item?.center?.southeast,
                                southwest: item?.center?.southwest,
                                center: item?.center?.center,
                                top: item?.center?.top,
                                bottom: item?.center?.bottom,
                                cce: item?.center?.cce,
                                ccw: item?.center?.ccw
                            },
                            top: {
                                north: item?.top?.north,
                                south: item?.top?.south,
                                east: item?.top?.east,
                                west: item?.top?.west,
                                northwest: item?.top?.northwest,
                                northeast: item?.top?.northeast,
                                southeast: item?.top?.southeast,
                                southwest: item?.top?.southwest,
                                center: item?.top?.center,
                                top: item?.top?.top,
                                bottom: item?.top?.bottom,
                                cce: item?.top?.cce,
                                ccw: item?.top?.ccw
                            },
                            bottom: {
                                north: item?.bottom?.north,
                                south: item?.bottom?.south,
                                east: item?.bottom?.east,
                                west: item?.bottom?.west,
                                northwest: item?.bottom?.northwest,
                                northeast: item?.bottom?.northeast,
                                southeast: item?.bottom?.southeast,
                                southwest: item?.bottom?.southwest,
                                center: item?.bottom?.center,
                                top: item?.bottom?.top,
                                bottom: item?.bottom?.bottom,
                                cce: item?.bottom?.cce,
                                ccw: item?.bottom?.ccw

                            },
                            cce: {
                                north: item?.cce?.north,
                                south: item?.cce?.south,
                                east: item?.cce?.east,
                                west: item?.cce?.west,
                                northwest: item?.cce?.northwest,
                                northeast: item?.cce?.northeast,
                                southeast: item?.cce?.southeast,
                                southwest: item?.cce?.southwest,
                                center: item?.cce?.center,
                                top: item?.cce?.top,
                                bottom: item?.cce?.bottom,
                                cce: item?.cce?.cce,
                                ccw: item?.cce?.ccw

                            },
                            ccw: {
                                north: item?.ccw?.north,
                                south: item?.ccw?.south,
                                east: item?.ccw?.east,
                                west: item?.ccw?.west,
                                northwest: item?.ccw?.northwest,
                                northeast: item?.ccw?.northeast,
                                southeast: item?.ccw?.southeast,
                                southwest: item?.ccw?.southwest,
                                center: item?.ccw?.center,
                                top: item?.ccw?.top,
                                bottom: item?.ccw?.bottom,
                                cce: item?.ccw?.cce,
                                ccw: item?.ccw?.ccw

                            }
                        }}
                        validationSchema={validationSchema}
                        onSubmit={(values) => {
                            const { east, south, southeast, southwest, north, west, northeast, northwest, top, bottom, center, cce, ccw, item1, item2 } = values
                            let updateData = { east, south, southeast, southwest, north, west, northeast, northwest, top, bottom, center, cce, ccw, item1, item2 }
                            updateConnection({ id: item?._id, data: updateData })
                        }}
                    >
                        {({ values, touched, errors, handleBlur, setValues }) => (
                            <Form noValidate autoComplete="off" >
                                <Typography id="modal-modal-title" variant='h6' mb={2}>
                                    Edit Connection Points
                                </Typography>

                                <Stack mt={2}>
                                    <Autocomplete
                                        disablePortal
                                        onChange={(_, value) => setValues({ ...values, item1: value })}
                                        name="item1"
                                        id="combo-box-demo"
                                        options={items}
                                        value={items?.find((obj) => obj._id === values?.item1)}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => <TextField placeholder='Select item1' name='item1' {...params} label="Item1"
                                            onBlur={handleBlur}
                                            helperText={
                                                getIn(touched, "item1") && getIn(errors, "item1")
                                                    ? getIn(errors, "item1")
                                                    : ""
                                            }
                                            error={Boolean(getIn(touched, "item1") && getIn(errors, "item1"))}
                                        />
                                        }
                                    />
                                </Stack>

                                <Stack mt={2}>
                                    <Autocomplete
                                        disablePortal
                                        onChange={(_, value) => setValues({ ...values, item2: value })}
                                        name="item2"
                                        id="combo-box-demo"
                                        value={items?.find((obj) => obj._id === values?.item2)}
                                        options={items}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => <TextField placeholder='Select item2' name='item2' {...params} label="Item2"
                                            onBlur={handleBlur}
                                            helperText={
                                                getIn(touched, "item2") && getIn(errors, "item2")
                                                    ? getIn(errors, "item2")
                                                    : ""
                                            }
                                            error={Boolean(getIn(touched, "item2") && getIn(errors, "item2"))}
                                        />
                                        }
                                    />
                                </Stack>

                                {values?.item1 &&
                                    <Stack justifyContent={"space-between"} flexDirection="row" mt={2}>
                                        <Stack>
                                            <Box>
                                                <img src={`${baseUrl}/g${items?.find((obj) => obj._id === values?.item1)?.frontViewImage}`} alt={values?.item1?.name} height="100px" />
                                            </Box>
                                        </Stack>
                                    </Stack>
                                }

                                {values?.item2 &&
                                    <Stack justifyContent={"space-between"} flexDirection="row" mt={2}>
                                        <Stack>
                                            <Box>
                                                <img src={`${baseUrl}/g${items?.find((obj) => obj._id === values?.item2)?.frontViewImage}`} alt={values?.item2?.name} height="100px" />
                                            </Box>
                                        </Stack>
                                    </Stack>
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>North Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, north: {
                                                                    ...values?.north, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.north?.[item.value])}
                                                            name={`north`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`north`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "north") && getIn(errors, "north")
                                                                        ? getIn(errors, "north")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "north") && getIn(errors, "north"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>South Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, south: {
                                                                    ...values?.south, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.south[item.value])}
                                                            name={`south`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`south`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "south") && getIn(errors, "south")
                                                                        ? getIn(errors, "south")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "south") && getIn(errors, "south"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>East Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, east: {
                                                                    ...values?.east, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.east[item.value])}
                                                            name={`east`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`east`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "east") && getIn(errors, "east")
                                                                        ? getIn(errors, "east")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "east") && getIn(errors, "east"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>West Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item?.label === "Center point between Center and East" ? "column" : item?.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, west: {
                                                                    ...values?.west, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.west[item.value])}
                                                            name={`west`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`west`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "west") && getIn(errors, "west")
                                                                        ? getIn(errors, "west")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "west") && getIn(errors, "west"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>North West Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, northwest: {
                                                                    ...values?.northwest, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.northwest[item.value])}
                                                            name={`northwest`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`northwest`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "northwest") && getIn(errors, "northwest")
                                                                        ? getIn(errors, "northwest")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "northwest") && getIn(errors, "northwest"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>North East Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, northeast: {
                                                                    ...values?.northeast, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.northeast[item.value])}
                                                            name={`northeast`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`northeast`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "northeast") && getIn(errors, "northeast")
                                                                        ? getIn(errors, "northeast")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "northeast") && getIn(errors, "northeast"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>South West Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, southwest: {
                                                                    ...values?.southwest, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.southwest[item.value])}
                                                            name={`southwest`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`southwest`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "southwest") && getIn(errors, "southwest")
                                                                        ? getIn(errors, "southwest")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "southwest") && getIn(errors, "southwest"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>South East Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, southeast: {
                                                                    ...values?.southeast, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.southeast[item.value])}
                                                            name={`southeast`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`southeast`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "southeast") && getIn(errors, "southeast")
                                                                        ? getIn(errors, "southeast")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "southeast") && getIn(errors, "southeast"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>Center Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, center: {
                                                                    ...values?.center, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.center[item.value])}
                                                            name={`center`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`center`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "center") && getIn(errors, "center")
                                                                        ? getIn(errors, "center")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "center") && getIn(errors, "center"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>Top Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, top: {
                                                                    ...values?.top, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.top[item.value])}
                                                            name={`top`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`top`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "top") && getIn(errors, "top")
                                                                        ? getIn(errors, "top")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "top") && getIn(errors, "top"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>Bottom Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, bottom: {
                                                                    ...values?.bottom, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.bottom[item.value])}
                                                            name={`bottom`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`bottom`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "bottom") && getIn(errors, "bottom")
                                                                        ? getIn(errors, "bottom")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "bottom") && getIn(errors, "bottom"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>Center point between Center and East Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, cce: {
                                                                    ...values?.cce, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.cce[item.value])}
                                                            name={`cce`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`cce`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "cce") && getIn(errors, "cce")
                                                                        ? getIn(errors, "cce")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "cce") && getIn(errors, "cce"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                {values?.item1 && values?.item2 && (
                                    <Box mt={2}>
                                        <Typography component="span" fontWeight={"bold"} fontSize={"20px"}>Center point between Center and East Points</Typography>
                                        <ListItem sx={{ flexDirection: "column", alignItems: "flex-start" }}>
                                            {connectionPointsData?.map((item, index) => {
                                                return (
                                                    <Stack key={index} my={1} flexDirection={item.label === "Center point between Center and East" ? "column" : item.label === "Center point between Center and West" ? "column" : "row"} width="100%" alignItems={item.label === "Center point between Center and East" ? "flex-start" : item.label === "Center point between Center and West" ? "flex-start" : "center"}>
                                                        <ListItemText
                                                            key={index}
                                                            primaryTypographyProps={{ style: { fontWeight: "bold", minWidth: "130px", marginRight: "10px" } }}
                                                            primary={item.label}
                                                        />

                                                        <Autocomplete
                                                            fullWidth
                                                            disablePortal
                                                            onChange={(_, value) => setValues({
                                                                ...values, ccw: {
                                                                    ...values?.ccw, [item.value]: (value || value == "") && value.value || 7
                                                                }
                                                            })}
                                                            value={connectionPointsOptionsData.find((item2) => item2.value === values?.ccw[item.value])}
                                                            name={`ccw`}
                                                            id="combo-box-demo"
                                                            options={connectionPointsOptionsData}
                                                            getOptionLabel={(option) => option.label}
                                                            renderInput={(params) => <TextField placeholder={"Select " + item.label + " Points"} name={`ccw`} {...params} label={item.label + " Points"}
                                                                onBlur={handleBlur}
                                                                helperText={
                                                                    getIn(touched, "ccw") && getIn(errors, "ccw")
                                                                        ? getIn(errors, "ccw")
                                                                        : ""
                                                                }
                                                                error={Boolean(getIn(touched, "ccw") && getIn(errors, "ccw"))}
                                                            />
                                                            }
                                                        />
                                                    </Stack>
                                                )
                                            })
                                            }
                                        </ListItem>
                                    </Box>
                                )
                                }

                                <Stack mt={2}>
                                    <LoadingButton loading={load} variant="contained" fullWidth type="submit">
                                        Add
                                    </LoadingButton>
                                </Stack>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Modal >
        </>
    );
}